import React from 'react';
import { CircularProgress } from '@mui/material';

const PageLoader = () => (
  <div className="page-loader-container">
    <CircularProgress sx={{ color: '#ED1C25' }} />
    <div className="page-loader-text" style={{ marginTop: '16px' }}>
      Loading...
    </div>
  </div>
);

export default PageLoader;
